// note: localStorage must be accessed via the helpers: localstorageGetItem, localstorageSetItem, localstorageRemoveItem

export const LOCAL_STORAGE_PREFIX = "clev-";

export const LOCAL_STORAGE_KEYS = {
  CART: "cart",
};
